import { openModal } from '@core/components/ModalStack';
import { AddEditContactModalProps } from './AddEditContactModal';

export async function openAddEditContactModal(props: AddEditContactModalProps) {
  const { AddEditContactModal } = await import('./AddEditContactModal');

  openModal(AddEditContactModal, props);
}
